export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003/api';
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || 'http://localhost:5003/';
export const JWT_SECRET = '123456';
export const REACT_APP_STATUS = process.env.REACT_APP_STATUS || 'development';
export const REACT_APP_STATUS_COLOR = process.env.REACT_APP_STATUS_COLOR || 'orange';
export const REACT_APP_GOOGLE_MAPS_API = process.env.REACT_APP_GOOGLE_MAPS_API || '123456';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';
export const ACCOUNT_APP_URL = process.env.REACT_APP_ACCOUNT_APP_URL;
